module.exports = __webpack_public_path__ + "static/media/mob-pain-withoutpink-bg.a9dcd93a.png";